import { google } from '../../../proto/protobuf';

type FormatTimestamp = (timestamp: number) => google.protobuf.ITimestamp;
export const formatTimestamp: FormatTimestamp = (timestamp) => {
  const date = new Date(timestamp);
  const nanos = date.getMilliseconds() * 1000;
  const seconds = Math.floor(date.getTime() / 1000);

  return { nanos, seconds };
};
